import InsightsUtils from "@bodeboca/algolia/utils/insights"
import aa from "search-insights"
import ApiService from "@bodeboca/api";

(function (Drupal, drupalSettings, aa) {
  Drupal.behaviors.bb_algolia_insights = {
    attach() {
      InsightsUtils.initInsights()
    },
  }
})(Drupal, drupalSettings, aa)
